<template>
  <v-container fluid class="ma-4 mt-8">
    <v-row>
      <v-col cols="12">
        <div class="mr-8 home-content" v-html="homeContent"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'LoggedInStart',

  components: {},

  data: () => ({
    contentLocale: ''
  }),

  computed: {
    ...mapGetters('app', ['homeContent', 'locale']),
    ...mapActions('app', ['showRightsholderForm'])
  },

  mounted() {
    if (!this.startContent || this.locale!==this.contentLocale) {
      this.$store.dispatch('app/loadHomeContent', this.locale)
      this.contentLocale = this.locale
    }
    window.showIfpiDialog = this.exposedFunction.bind(this)
  },

  watch: {
    locale() {
      this.$store.dispatch('app/loadHomeContent', this.locale)
      this.contentLocale = this.locale
    },
  },

  methods: {
    async exposedFunction(val) {
      await this.$store.dispatch('app/showRightsholderForm', val.form)
      return false;
    }
  }
}
</script>

<style scoped>
  .home-content p {
    word-wrap: break-word;
  }
</style>